var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "root" }, [
    _vm.memoId
      ? _c(
          "div",
          { staticClass: "container" },
          [
            _c("slide-tag-menu", {
              attrs: {
                memo: _vm.editingMemo,
                onChange: _vm.change,
                novelSelectable: !_vm.inNovel,
                memoContext: true,
              },
            }),
            _c("div", { staticClass: "memo-header" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editingMemo.title,
                    expression: "editingMemo.title",
                  },
                ],
                staticClass: "title",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("memoPage.memoDetail.titlePlaceholder"),
                  maxlength: "50",
                  readonly: _vm.readonly,
                },
                domProps: { value: _vm.editingMemo.title },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.editingMemo, "title", $event.target.value)
                    },
                    _vm.change,
                  ],
                },
              }),
              _c("div", { staticClass: "header-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "header-history-icon",
                    class: { disabled: _vm.readonly },
                    attrs: {
                      "aria-label": _vm.$t("memoVersionsDialog.historyButton"),
                      role: "button",
                      tabindex: "0",
                    },
                    on: {
                      click: function ($event) {
                        !_vm.readonly && _vm.showVersions()
                      },
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          !_vm.readonly && _vm.showVersions()
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          )
                            return null
                          $event.preventDefault()
                          !_vm.readonly && _vm.showVersions()
                        },
                      ],
                    },
                  },
                  [
                    _c("history-icon", {
                      staticClass: "icon",
                      attrs: {
                        fillColor: _vm.isVersionsDialogOpen
                          ? _vm.activeColor
                          : _vm.defaultColor,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "button header-delete",
                    on: { click: _vm.onDeleteButtonClick },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.delete")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button header-save",
                    class: { active: _vm.isChanged },
                    attrs: { disabled: !_vm.isChanged },
                    on: { click: _vm.onSaveButtonClick },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                ),
              ]),
            ]),
            _c("div", { staticClass: "text" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content",
                  },
                ],
                staticClass: "textarea",
                attrs: {
                  id: _vm.memoTextareaId,
                  disabled: _vm.content === null,
                  placeholder: _vm.$t("memoPage.memoDetail.contentPlaceholder"),
                  readonly: _vm.readonly,
                },
                domProps: { value: _vm.content },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.content = $event.target.value
                    },
                    _vm.change,
                  ],
                },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "selected-tag-container",
                class: { none: !_vm.hasMemoTags },
              },
              [
                _c(
                  "div",
                  { staticClass: "tag-icon" },
                  [_c("tag-icon", { attrs: { fill: _vm.iconColor } })],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "tag-chip-list" },
                  _vm._l(_vm.selectedMemoTags, function (memoTag) {
                    return _c("chip", {
                      key: memoTag.id,
                      attrs: { value: memoTag.name },
                    })
                  }),
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "bottom" }, [
              _c(
                "div",
                { staticClass: "button-row" },
                [
                  _c("editor-controller", {
                    staticClass: "memo-editor-controller",
                    attrs: {
                      showSearchReplace: false,
                      showUndoRedo: false,
                      showRuby: false,
                      showEmphasisMark: false,
                      "textarea-id": _vm.memoTextareaId,
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "text-counter" }, [
                _c("div", { staticClass: "mode-select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentCountType,
                          expression: "currentCountType",
                        },
                      ],
                      style: { backgroundImage: _vm.selectArrowIcon },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.currentCountType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.countTypesArray, function (countType, index) {
                      return _c(
                        "option",
                        { key: countType, domProps: { value: countType } },
                        [_vm._v(" " + _vm._s(_vm.countTypes[index]) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" " + _vm._s(_vm.counter) + " "),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }